import React from "react"
import styled from "styled-components"

import {
  PrismicImage,
  StyledHeading,
  BodyCopy,
  CallToAction,
} from "../../common"

const MediumBannerWrapper = styled.div`
  position: relative;
  width: 100%;
  text-align: center;
  .gatsby-image-wrapper,
  img {
    width: 100%;
    height: auto;
    object-fit: cover;
  }
  button {
    margin: 2rem auto 0;
  }
  h1 {
    margin: 1rem 0;
  }
  ${BodyCopy} {
    font-weight: 700;
  }
  @media ${(props) => props.theme.breakpoints.ns} {
    height: 35vh;
    display: flex;
    align-items: center;
    justify-content: left;
    text-align: left;
    h1 {
      margin: 0 0;
    }
    button {
      margin: 2rem 0 0;
    }
    .gatsby-image-wrapper,
    img {
      z-index: -1;
      position: absolute !important;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  @media ${(props) => props.theme.breakpoints.large} {
    height: 50vh;
  }
`

const BannerTextContent = styled.div`
  /* padding: 2rem 2.3rem; */
  @media ${(props) => props.theme.breakpoints.ns} {
    max-width: 600px;
    padding: 1rem 0 1rem ${(props) => props.theme.wrappers.standard};
    h1,
    div {
      color: ${(props) => (props.color ? props.color : "#fff")};
    }
  }
`

export const MediumBanner = ({
  banner_image,
  banner_title,
  banner_subtitle,
  background_color,
  text_color,
  link_type,
  link_text,
  link_target,
  page_link,
}) => {
  const isImage = banner_image.url
  return (
    <MediumBannerWrapper isImage={isImage}>
      {isImage && <PrismicImage {...banner_image} />}

      <BannerTextContent background={background_color} textColor={text_color}>
        <StyledHeading size="h1" as="h1">
          {banner_title?.text}
        </StyledHeading>
        <BodyCopy>{banner_subtitle?.text}</BodyCopy>
        <CallToAction
          type={link_type}
          text={link_text}
          target={link_target}
          page={page_link}
        />
      </BannerTextContent>
    </MediumBannerWrapper>
  )
}
